import { render, staticRenderFns } from "./CreateDtc.vue?vue&type=template&id=0fad4de4&scoped=true&"
import script from "./CreateDtc.vue?vue&type=script&lang=js&"
export * from "./CreateDtc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fad4de4",
  null
  
)

export default component.exports